import { Component, Input } from '@angular/core';
import { CredentialDefinitionType } from 'src/app/shared/models/credential/credential-definition.model';
import { PaymentService } from 'src/shared-app-portal/services/payment.service';
import { InvoiceModel } from '../invoice-model';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss'],
  standalone: false
})
export class PaymentConfirmationComponent {
  @Input({ required: true }) invoice: InvoiceModel;
  @Input() checkInstructions: string;
  @Input({ required: true }) isConfirmationPage: boolean;
  @Input() displayTableOnly: boolean = false;
  constructor(private paymentService: PaymentService) {}

  displayEntityName(): string {
    return this.paymentService.isPerson && this.invoice.invoiceType == CredentialDefinitionType.Team
      ? this.invoice.entityName
      : '';
  }

  getTotalDisplay() {
    return {
      amount: this.invoice.amount,
      label: 'Total'
    };
  }

  get transactionDateLabel() {
    return this.invoice.paymentType ? 'Transaction Date' : 'Invoice Generated';
  }
  get orderNumberLabel() {
    return this.invoice.paymentType ? 'Invoice Number' : 'Order Number';
  }
}
